export const SITE_TITLE = "CorporatesClub.com";

export function formatDocumentTitle(pageTitle?: string | null): string {
  const trimmed = pageTitle?.trim();
  if(!trimmed) return SITE_TITLE;
  return `${trimmed} | ${SITE_TITLE}`;
}
